import '../../assets/index40.css';var y = Object.defineProperty, k = Object.defineProperties;
var L = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var f = (o, s, r) => s in o ? y(o, s, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[s] = r, m = (o, s) => {
  for (var r in s || (s = {}))
    u.call(s, r) && f(o, r, s[r]);
  if (c)
    for (var r of c(s))
      h.call(s, r) && f(o, r, s[r]);
  return o;
}, l = (o, s) => k(o, L(s));
var d = (o, s) => {
  var r = {};
  for (var e in o)
    u.call(o, e) && s.indexOf(e) < 0 && (r[e] = o[e]);
  if (o != null && c)
    for (var e of c(o))
      s.indexOf(e) < 0 && h.call(o, e) && (r[e] = o[e]);
  return r;
};
import { jsx as N, jsxs as R } from "react/jsx-runtime";
import F from "react";
import { ArrowRightFarFAIcon as j } from "../Icons/index.js";
import { u as v, c as P } from "../../factory-ueRxoNOV.js";
import { p as T } from "../../polymorphic-factory-DufevJAl.js";
import { T as b } from "../../Text-B7Ta53Id.js";
var w = { root: "m_849cf0da" };
const g = {
  underline: "hover"
}, p = T((o, s) => {
  const i = v(
    "Anchor",
    g,
    o
  ), { underline: r, className: e, unstyled: n, mod: t } = i, a = d(i, ["underline", "className", "unstyled", "mod"]);
  return /* @__PURE__ */ N(
    b,
    l(m({
      component: "a",
      ref: s,
      className: P({ [w.root]: !n }, e)
    }, a), {
      mod: [{ underline: r }, t],
      __staticSelector: "Anchor",
      unstyled: n
    })
  );
});
p.classes = w;
p.displayName = "@mantine/core/Anchor";
const z = "Link-module__root___w-X8e", D = "Link-module__icon___DK4Ro", A = {
  root: z,
  icon: D
}, I = F.forwardRef((i, a) => {
  var _ = i, {
    children: o,
    variant: s = "inline",
    disabled: r,
    className: e,
    icon: n = j
  } = _, t = d(_, [
    "children",
    "variant",
    "disabled",
    "className",
    "icon"
  ]);
  const x = s === "standalone";
  return /* @__PURE__ */ R(
    p,
    l(m({
      ref: a,
      className: e,
      classNames: A,
      "data-disabled": r || void 0,
      mod: {
        variant: s
      }
    }, t), {
      children: [
        o,
        x && /* @__PURE__ */ N(n, { size: 14, className: A.icon })
      ]
    })
  );
});
I.displayName = "Link";
export {
  I as Link
};
